import {
    TRAINING_SESSION_PARTICIPANT_UPDATE
} from "./constants";
const initialState = {
    isLoading: false,
    success: null
};

export default (state = initialState,action)=>{
    if (action.type){
        switch (action.type){
            case TRAINING_SESSION_PARTICIPANT_UPDATE.REQUEST:
                state = {
                    ...state,
                    isLoading: true,
                    success: null
                }
                break;
            case TRAINING_SESSION_PARTICIPANT_UPDATE.FAIL:
                state = {
                    ...state,
                    isLoading: false,
                    success: true
                }
                break;
            case TRAINING_SESSION_PARTICIPANT_UPDATE.SUCCESS:
                state = {
                    ...state,
                    isLoading: action.payload.data,
                    success: false
                }
                break;
            default:
                break;
        }
    }
    return state;
}